import React, { useEffect, useState } from 'react';
import { 
  WarningOutlined, 
  ReloadOutlined, 
  HomeOutlined, 
  ThunderboltOutlined, 
  CoffeeOutlined,
  ClockCircleOutlined 
} from '@ant-design/icons';

export default function EnhancedErrorPage() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    setMounted(true);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-primary to-secondary flex items-center justify-center p-4 overflow-hidden relative">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-purple-500/10 rounded-full blur-3xl -top-48 -left-48 animate-pulse"></div>
        <div className="absolute w-96 h-96 bg-blue-500/10 rounded-full blur-3xl -bottom-48 -right-48 animate-pulse" style={{ animationDelay: '700ms' }}></div>
      </div>

      <div className={`relative z-10 max-w-2xl w-full transition-all duration-1000 ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20">
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 animate-ping">
                <CoffeeOutlined className="text-amber-400/50" style={{ fontSize: '96px' }} />
              </div>
              <div className="relative bg-gradient-to-br from-amber-400 to-orange-500 p-6 rounded-full shadow-lg">
                <CoffeeOutlined className="text-white animate-bounce" style={{ fontSize: '48px' }} />
              </div>
              
              <ThunderboltOutlined className="absolute -top-2 -right-2 text-yellow-300 animate-pulse" style={{ fontSize: '32px' }} />
              <ThunderboltOutlined className="absolute -bottom-2 -left-2 text-yellow-300 animate-pulse" style={{ fontSize: '24px', animationDelay: '300ms' }} />
            </div>
          </div>

        

          <h1 className="text-4xl md:text-5xl font-bold text-center text-white mb-4">
            Oops! Something
            <span className="block  text-secondary">
              Went Wrong
            </span>
          </h1>

          <p className="text-gray-300 text-center text-lg mb-8 leading-relaxed">
              <span className="text-sm text-gray-200">
              We're Working on the problem
            </span>
            <br />
            <span className="text-sm text-gray-200">
              Have you tried turning it off and on again?
            </span>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleRefresh}
              className="group relative w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-primary to-secondary text-white rounded-xl font-semibold shadow-lg hover:shadow-secondary transition-all duration-300 hover:scale-105 active:scale-95 overflow-hidden"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                <ReloadOutlined className="text-xl group-hover:rotate-180 transition-transform duration-500" />
                Try Again
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>

        
          </div>

          <div className="mt-8 pt-6 border-t border-white/10">
            <p className="text-center text-gray-100 text-sm">
              If the problem persists, please contact our{' '}
              <a href="mailto:zentixsoftware@gmail.com" className="text-secondary hover:text-purple-300 underline transition-colors">
                support team
              </a>
            </p>
          </div>
        </div>

       
      </div>
    </div>
  );
}